export const MAX_INPUT_HEIGHT = 40;
